import { render, staticRenderFns } from "./21-05-2025.vue?vue&type=template&id=4f17034e"
import script from "./21-05-2025.vue?vue&type=script&lang=js"
export * from "./21-05-2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports